import { Component, OnInit } from '@angular/core';
import { CamperVan } from '../../models/campervan';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window/directives/snazzy-info-window';
import { Observable } from 'rxjs/Observable';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { ClusterStyle } from '@agm/js-marker-clusterer/services/google-clusterer-types';

@Component({
  selector: 'map-test',
  templateUrl: './map-test.component.html',
  styleUrls: ['./map-test.component.css']
})
export class MapTestComponent implements OnInit {

  campervanCollection: AngularFirestoreCollection<CamperVan>;
  campervans: Observable<CamperVan[]>;
  selectedCampervanId: string;

  // Zoom Level
  zoom = 4;
  // setting Default Locations
  lat = 51.678418;
  lng = 7.809007;

  openSnazzy: boolean = false;

  
  public mapStyle = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#444444"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2f2f2"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#46bcec"
        },
        {
          visibility: "on"
        }
      ]
    }
  ];

  constructor(private afs: AngularFirestore) { }

  ngOnInit() {

    this.campervanCollection = this.afs.collection('campervans', ref => {
      return ref.orderBy('createdAt', 'desc');
    });
    this.campervans = this.campervanCollection.valueChanges();
  }


  mapClicked($event: any) {
    console.log("Map Clicked", $event.coords.lat, $event.coords.lng);
  }

  markerClick(i, e) {
    console.log('Marker Index:', i);
    console.log('Event:', e);
  }


  openSnazzyWindow(e, id, lat, lng) {
    console.log('my e:', e);
    console.log('my id:', id);
    console.log('my lat:', lat);
    console.log('my lng:', lng);
    this.lat = lat;
    this.lng = lng;
    this.zoom = 12;
   
    console.log('mySnazzy', this.openSnazzy);
    if (this.selectedCampervanId === id) {
      this.zoom = 12;
      this.openSnazzy = !this.openSnazzy;
      console.log('mySnazzy', this.openSnazzy);
    } else {
      this.zoom = 12;
      this.openSnazzy = true;
      console.log('mySnazzy', this.openSnazzy);
    }
    this.selectedCampervanId = id;
  
    console.log('my zoom:', this.zoom);
  }
  
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/map-test/map-test.component.ts